import React from 'react';

const reviews = [
  {
    quote: 'Fiz meu tratamento de implante com o Dr. Marcio e me senti seguro em todas as etapas. O resultado devolveu minha mastigação e minha confiança.',
    stars: '★★★★★',
    initials: 'JC',
    name: 'Juliana C.',
    meta: 'Implantes · 2025',
  },
  {
    quote: 'Tinha medo de dentista e hoje levo meus dois filhos sem drama nenhum. Atendimento humano de verdade.',
    stars: '★★★★★',
    initials: 'RM',
    name: 'Rafael M.',
    meta: 'Odontopediatria · 2025',
  },
  {
    quote: 'Fiz implante e prótese e recuperei a mastigação e a confiança no sorriso. Profissionais de altíssimo nível.',
    stars: '★★★★★',
    initials: 'LS',
    name: 'Lucia S.',
    meta: 'Implantes · 2024',
  },
];

const Reviews = () => (
  <>
    <div className="divider" id="depoimentos">
      <span><span className="dot"></span> 04 / Depoimentos</span>
      <span>O que dizem nossos pacientes</span>
    </div>

    <section className="depos">
      <div className="depos-head">
        <h2 className="display">
          O que nossos <em>pacientes</em><br />contam por aí.
        </h2>
      </div>

      <div className="depos-track">
        {reviews.map((r, i) => (
          <article className="depo" key={i}>
            <div className="stars">{r.stars}</div>
            <p className="quote">{r.quote}</p>
            <div className="depo-person">
              <div className="avatar">{r.initials}</div>
              <div>
                <div className="name">{r.name}</div>
                <div className="meta">{r.meta}</div>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  </>
);

export default Reviews;
